import React from "react";

import { useSelector } from "../../utils/hooks";

import "./ConfigService.scss";

// Services already in the cart with the product, e.g. picked on the product page
export const AttachedConfigServices = () => {
	const attachedServices = useSelector(
		(state) => state.popup.attachedConfigServices,
	);

	if (!attachedServices?.length) {
		return null;
	}

	return (
		<section className="addtocart-attachedConfigServices">
			{attachedServices.map((service) => {
				const selectedOption = service.options?.find(
					(option) => option.selected,
				);

				return (
					<div
						key={service.id}
						className="addtocart-configServices"
						data-testid={`attached-config-service-${service.id}`}
					>
						<div className="addtocart-configServices__info">
							<h2>{service.displayName}</h2>

							<div
								className="addtocart-insurance__info--description"
								dangerouslySetInnerHTML={{
									__html: selectedOption?.name || service.description,
								}}
							/>
						</div>
                        
						<div className="addtocart-configServices__price">
							<strong>{selectedOption?.price || service.price}</strong>
						</div>
					</div>
				);
			})}
		</section>
	);
};
